import React from 'react';
import _ from 'lodash';
import Grid from '../../../../grid/Grid';
import SearchBar from '../../../../searchbar/SearchBar';
import FieldSet from '../../../../fieldset/FieldSet';
import { EMPTY_GRID_DEFAULT_MESSAGE, } from '../../../../../modules/Constants';
import NcDmvCrashReportsModal from './NcDmvCrashReportsModal';
import NcDmvCrashReportsService from '../../../../../service/NcDmvCrashReportsService';

export default class NcDmvCrashReports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      headers: [],
    };

    this.comboFields = [
      {
        value: 'externalAccountId',
        display: 'Requester\'s Driver\'s License Number',
      },
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'transactionId',
        display: 'Transaction Id',
      },
    ];
  }

  onCrashReportSelect(row) {
    const { rows = [], } = this.state;
    const selectedCrashReport = rows.find(order => order.raw.id === row.id);
    this.setState({
      selectedCrashReport: selectedCrashReport.raw,
    });
  }

  getCrashReports(event) {
    const { search, combo, } = event;
    this.reset();

    const vm = this;
    const headers = [];
    const rows = [];
    const criteria = {};
    criteria[combo.value] = search.value;
    criteria.serviceOfferingId = 'ncdmv_crash_reports';

    const allowedKeys = [
      'id',
      'externalAccountId',
      'customerId',
      'paymentAmount',
      'paymentTransactionId',
      'paymentDate',
    ];

    NcDmvCrashReportsService.getNcDmvCrashReportsBySearchCriteria(criteria)
      .then((response) => {
        const { crashReports, } = response.data;
        if (crashReports.length > 0) {
          allowedKeys.forEach((allowedKey) => {
            headers.push({
              value: allowedKey,
              display: _.startCase(allowedKey),
            });
          });
          crashReports.forEach((crashReport) => {
            const filtered = _.pick(crashReport, allowedKeys);
            rows.push({
              value: Object.values(filtered),
              raw: crashReport,
            });
          });
        }
        vm.setState({
          headers,
          rows,
        });
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        event.kill();
      });
  }

  formatSelectedRowDisplay = (crashReport) => {
    if (!crashReport) {
      return null;
    }

    return (
      <div>
        <p>{`Selected ID: ${crashReport.id}`}</p>
        <hr />
        <NcDmvCrashReportsModal selectedCrashReport={crashReport} />
      </div>
    );
  };

  reset() {
    this.setState({
      rows: [],
      headers: [],
      selectedCrashReport: null,
    });
  }

  render() {
    const {
      headers = [],
      rows = [],
      selectedCrashReport,
    } = this.state;

    return (
      <div className="container">
        <SearchBar
          comboFields={this.comboFields}
          onClick={data => this.getCrashReports(data)}
        />
        <div style={{ marginTop: '50px', }}>
          <FieldSet title="Crash Reports">
            <Grid
              headers={headers}
              rows={rows}
              style={{ maxHeight: '800px', overflowY: 'auto', }}
              onRowSelect={data => this.onCrashReportSelect(data)}
              onEmptyGridMessage={EMPTY_GRID_DEFAULT_MESSAGE}
            />
          </FieldSet>
          {this.formatSelectedRowDisplay(selectedCrashReport)}
        </div>
      </div>
    );
  }
}
